<template>
  <div class="flex justify-content-center">
    <div>
      <form ref="form" @submit.prevent="saveUser">
        <div class="form-group">
          <label>Номер карты</label>
          <div class="input-group">
            <input required type="text" v-model="card.number" class="form-control">
            <div class="input-group-append">
              <select v-model="card.type" class="form-control">
                <option value="1">VISA</option>
                <option value="2">MASTER</option>
                <option value="3">МИР</option>
                <option value="5">QiWi</option>
              </select>
            </div>
          </div>
        </div>

        <div class="form-group" v-if="+card.type === 5">
          <label>Пароль к кошельку</label>
          <input type="text" v-model="card.extra_options.password" class="form-control">
        </div>

        <div class="form-group">
          <label>Комментарий к счету</label>
          <input type="text" v-model="card.extra_options.comment" class="form-control">
        </div>

        <div class="form-group">
          <label>Статус аккаунта</label>
          <select v-model="card.extra_options.status" class="form-control">
            <option value="regular">Основной</option>
            <option value="professional">Професиональный</option>
          </select>
        </div>

        <div class="form-group">
          <label>Назначение карты</label>
          <select v-model="card.use_type_id" class="form-control">
            <option v-for="t in useTypes" :value="t.id">{{ t.title }}</option>
          </select>
        </div>
        <div class="form-group">
          <label>Владелец карты</label>
          <div v-if="false">
            <label><input type="checkbox" v-model="user.isNew"> Новый владелец</label>
          </div>
        </div>
        <template v-if="user.isNew">
          <div class="form-group">
            <label>Фамилия Инициалы</label>
            <input required type="text" v-model="user.short_name" class="form-control">
          </div>
          <div class="form-group">
            <label>ФИО</label>
            <input type="text" v-model="user.full_name" class="form-control">
          </div>
          <div class="form-group">
            <label>Bank login</label>
            <input type="text" v-model="user.banking_login" class="form-control">
          </div>
          <div class="form-group">
            <label>Bank password</label>
            <input type="text" v-model="user.banking_password" class="form-control">
          </div>
        </template>
        <template v-else>
          <div class="form-group">
            <select v-model="user.id" class="form-control">
              <option disabled value="0">Выберите владельца</option>
            </select>
          </div>
        </template>
        <div class="form-group">
          <label>Комментарий</label>
          <input type="text" v-model="user.options.comment" class="form-control">
        </div>
        <div class="alert alert-info" v-if="!user.id">
          <p>Добавление файлов возможно, после сохранения карты</p>
        </div>
        <button ref="submit" type="submit" class="hidden">submit</button>
      </form>
    </div>
    <div class="ml-2">

      <div class="form-group">
        <label>Proxy адрес</label>
        <input type="text" v-model="card.extra_options.proxy.address" class="form-control">
      </div>
      <div class="form-group">
        <label>Proxy порт</label>
        <input type="text" v-model="card.extra_options.proxy.port" class="form-control">
      </div>
      <div class="form-group">
        <label>Proxy логин</label>
        <input type="text" v-model="card.extra_options.proxy.user" class="form-control">
      </div>
      <div class="form-group">
        <label>Proxy пароль</label>
        <input type="text" v-model="card.extra_options.proxy.pass" class="form-control">
      </div>

      <div v-if="card.id">
        <UploadCustomWithPreview
          :allowToUpload="true"
          :extraData="{object: 'credit_card', objectId: card.id}"
        />
      </div>

    </div>
  </div>
</template>

<script>

import api from "@/api";
import UploadCustomWithPreview from "@/components/images/UploadCustomWithPreview.vue";

export default {
  components: {UploadCustomWithPreview},
  props: ['modalData'],
  data() {
    return {
      saveLoading: false,
      useTypes: [
        {id: 1, title: 'Почтовые поступления'},
        {id: 3, title: 'Предоплата регионов'}
      ],
      user: {
        isNew: true,
        id: 0,
        banking_login: null,
        banking_password: null,
        short_name: null,
        full_name: null,
        options: {comment: null}
      },
      card: {
        id: null,
        number: null,
        type: 5,
        use_type_id: 1,
        extra_options: {
          status: 'regular',
          proxy: {}
        }
      }
    }
  },
  methods: {
    async saveUser() {
      console.log('save');
      this.modalData.acceptBtnLoading = true;
      const {data} = await api.post('/cards/updateCard', {
        action: 'newCard',
        card: this.card,
        user: this.user,
      })
      if (data.success) {
        toastr['success']('Сохранено');
        this.card.id = data.record.id;
        this.user.id = data.record.user_id;
      } else {
        toastr['warning'](data.message || 'Ошибка');

      }
      this.modalData.acceptBtnLoading = false;
    }
  }
}

</script>

<style scoped>
label {
  margin-bottom: 2px;
}
</style>
